import React, {Component} from "react";
import SportIcon from "../SportIcon";
import Xhr from "../../helpers/Xhr";
import {Link} from "react-router-dom";
import Leagues from "./Leagues";
import Loading from "./Loading";

class Item extends Component {
	state = {
		isOpened : false,
		isLoaded : false,
		fetching : false,
		leagues  : []
	};

	constructor(props) {
		super(props);
		this.handlerDropdown = this.handlerDropdown.bind(this);
	}

	handlerDropdown() {
		if ( !this.state.isOpened ) {
			if ( !this.state.isLoaded ) {
				this.setState({fetching : true}, () => {
					Xhr.getLeague(this.props.sport.id).then((resp) => {
						this.setState({
							leagues  : resp ? resp.data : [],
							fetching : false,
							isLoaded : true,
							isOpened : true
						});
					});
				});
			}
			else {
				this.setState({isOpened : true});
			}
		}
		else {
			this.setState({isOpened : false});
		}
	}

	render() {
		return (
			<div>
				<li className={this.state.isOpened ? 'opened' : ''} onClick={this.handlerDropdown}>
					<div className="event-list__underline">
						<span className="event-list__icon">
							<span className="sport-icon small">
								<SportIcon sportId={parseInt(this.props.sport.id)}/>
							</span>
						</span>
						<span>
							<Link to={`/line-select/${this.props.sport.id}`} onClick={(event) => event.stopPropagation()}>{this.props.sport.name}</Link>&nbsp;
							<sup>{this.props.sport.countEvents}</sup>
						</span>

						<span className={`event-list__arrow ${this.state.isOpened ? 'up' : 'down'}`}>
							{this.state.fetching ? <Loading/> :
								<i className={`fas ${this.state.isOpened ? 'fa-caret-up' : 'fa-caret-down'}`}></i>}
						</span>
					</div>
				</li>

				<div className={`event-list__sub ${this.state.isOpened ? 'show' : ''}`}>
					<form>
						<Leagues data={this.state.leagues}
						         selectLeague={this.props.selectLeague}/>

						<div className="buttons">
							<Link to={this.props.action} className="buttons__show">Показать</Link>
							<button className="buttons__clear" type="reset">Очистить</button>
						</div>
					</form>
				</div>
			</div>
		)
	}
}

export default Item;


// WEBPACK FOOTER //
// ./src/app/components/LineWidget/Item.js